<aside
  class="bn-sidebar"
  [ngClass]="{ 'bn-sidebar--is-open': isMobileMenuOpened }">
  <header class="bn-sidebar__header">
    <div class="bn-level">
      <div class="bn-level--left">
        <a
          class="bn-sidebar__logo"
          routerLink="/">
          <img
            class="bn-sidebar__logo-img"
            src="assets/images/logo-bunnynet-icon.svg" />
        </a>
      </div>
      <div class="bn-level--right">
        <div class="d-none d-lg-flex">
          <bn-dashboard-notifications
            class="bn-level__item me-4"
            data-e2e="SidebarNotifications" />
          <bn-layout-user-profile
            class="bn-level__item"
            [accountRoute]="accountRoute"
            [billingBalance]="billingBalance()"
            [billingRoute]="billingRoute"
            [email]="userEmail()"
            [fullName]="userFullName()"
            [menuItems]="userProfileMenuItems()"
            [showBilling]="showBilling()"
            (logout)="onLogout()" />
        </div>
        <a
          class="bn-sidebar__mobile__close d-flex d-lg-none"
          (click)="onMenuItemClick('toggle-menu')"
          ><fa-icon
            class="bn-sidebar__mobile__close-icon"
            icon="xmark"
        /></a>
      </div>
    </div>
  </header>
  <div class="bn-sidebar__main">
    <div class="bn-sidebar__search">
      <bn-dashboard-search />
    </div>
    <bn-layout-user-profile
      class="d-lg-none"
      [accountRoute]="accountRoute"
      [billingBalance]="billingBalance()"
      [billingRoute]="billingRoute"
      [email]="userEmail()"
      [fullName]="userFullName()"
      [isMobile]="true"
      [menuItems]="userProfileMenuItems()"
      [showBilling]="showBilling()"
      (logout)="onLogout()" />
    <bn-dashboard-notifications
      class="d-lg-none"
      [isMobile]="true" />
    <bn-layout-main-menu
      [childRoutes]="mainMenuChildRoutes"
      [defaultOpenSections]="defaultOpenSections"
      [homeRoute]="homeRoute"
      [menuConfig]="mainMenuConfig" />

    <div
      *roleIds="['SubuserManage']"
      class="px-4 d-none d-lg-block">
      <bn-web-ui-dropdown-menu
        #addDropdown
        [aboveLoader]="true"
        [hasContentShadow]="true"
        [options]="{
          size: 'auto',
          position: 'right',
          align: 'center',
          isFullWidth: true,
        }"
        (dropDownStateChanged)="onDropDownStateChanged($event)">
        <button
          bn-web-ui-button
          data-e2e="MainMenuAddButton"
          itemStyle="primary-alter"
          leftIcon="plus"
          size="lg"
          trigger
          [active]="isDropdownOpened"
          [fullWidth]="true">
          <span>Add</span>
        </button>
        @if (isDropdownOpened) {
          <bn-dashboard-add-menu
            content
            data-e2e="MainMenuAddButtonMenu"
            [menuItems]="addDropdownLinks"
            (itemClickedEvent)="addDropdown.toggleDropdown()" />
        }
      </bn-web-ui-dropdown-menu>
    </div>
  </div>
  <ul class="bn-sidebar__bottom">
    <li
      *roleIds="['SubuserBilling']"
      class="bn-sidebar__bottom__item">
      @if (!userStore.hidePricing()) {
        <bn-dashboard-billing-overview />
      }
    </li>
    <li
      *roleIds="['SubuserSupport']"
      class="bn-sidebar__bottom__item">
      <bn-dashboard-support />
    </li>
    @if (versionCheckService.showVersion$ | async) {
      <li class="bn-sidebar__bottom__item px-3 py-2">
        <small class="bn-main-menu__link">
          <strong>Current version:</strong> {{ (versionCheckService.versions$ | async)?.currentVersion }} <br />
          <strong>Prod version:</strong> {{ (versionCheckService.versions$ | async)?.productionVersion }}<br />
          @if ((versionCheckService.versions$ | async)?.jiraIssue) {
            <strong
              ><a
                class="text-dark-4"
                target="_blank"
                [href]="(versionCheckService.versions$ | async)?.jiraIssue"
                ><fa-icon icon="external-link" /> Jira issue</a
              ></strong
            >
          }
          <br />
          @if ((versionCheckService.versions$ | async)?.jiraIssue) {
            <strong
              ><a
                class="text-dark-4"
                target="_blank"
                [href]="(versionCheckService.versions$ | async)?.pullRequest"
                ><fa-icon icon="external-link" /> Pull Request</a
              >
            </strong>
          }
        </small>
      </li>
    }
  </ul>
</aside>
